import Indicator, { IndicatorType } from '../types/Indicator'

const ParabolicSAR: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'parabolicSAR',
  label: 'Parabolic SAR',
  nickname: 'Parabolic SAR',
  fields: ['parabolicSAR'],
  params: {
    step: 0.02,
    max: 0.2,
  },
}

export default ParabolicSAR
